export default "__VITE_ASSET__DJbTS5Jy__"